import { MODAL_TYPES } from './contactFormConstants';

export const basicConsultationPayload = {
  dealer: { active: true },
  country: { active: true },
  language: { active: true },
  market: { active: true },
  assignToDealer: { active: true },
  campaign: { active: true },
  type: { active: true },
  title: { active: true },
  firstName: { active: true, inputRequired: true },
  lastName: { active: true, inputRequired: true },
  email: { active: true, inputRequired: true },
  telephone: { active: true },
  emailOptIn: { active: true },
  telephoneOptIn: { active: true },
  doubleOptIn: { active: true },
  comments: { active: true },
  customerSupportMessage: { active: true },
  gReCaptchaToken: { active: true },
};

const basicFieldsConfig = {
  showOSBLink: false,
  showServiceRequest: false,
  showConfigurator: false,
  showAppointmentType: false,
  showAppointmentDate: false,
  showAppointmentDescription: false,
  showAppointmentPersonalData: false,
  showInformationAndButtons: false,
  titleIsOptional: false,
  useNestedPayloadType: false,
  requestUrl: '/api/v1/contact/',
};

const ONLINE_SERVICE_BOOKING = {
  payloadConfig: {},
  fieldsConfig: { ...basicFieldsConfig, showOSBLink: true, showOSBLinkIcons: true },
  modaltypeToWriteInUrl: 'ONLINE_SERVICE_BOOKING',
  mainHeader: 'Werkstatttermin bequem online buchen',
  modalName: 'ONLINE_SERVICE_BOOKING',
};

const SERVICE_BOOKING_FALLBACK = {
  payloadConfig: { ...basicConsultationPayload, title: { active: true, inputRequired: true } },
  trackingConfig: {
    trackingLabel: 'conversion:servicecontact',
    errorLabel: 'servicecontact',
  },
  fieldsConfig: {
    ...basicFieldsConfig,
    showServiceRequest: true,
    showAppointmentPersonalData: true,
    titleIsOptional: false,
    useNestedPayloadType: true,
    requestUrl: '/api/v1/service-appointments/',
    showInformationAndButtons: false,
    showInformationAndButtonsTypeService: true,
    serviceRequestInformation:
      'Sie haben eine Frage rund um die Themen Wartung, Teile und Zubehör oder möchten einfach nur eine allgemeine Frage stellen? Bitte lassen Sie uns wissen, wie wir Ihnen weiterhelfen können.',
  },
  modaltypeToWriteInUrl: 'SERVICE_BOOKING_FALLBACK',
  mainHeader: 'Serviceberater kontaktieren',
  modalName: 'SERVICE_BOOKING_FALLBACK',
};

const SERVICE_REQUEST = {
  ...SERVICE_BOOKING_FALLBACK,
  trackingConfig: {
    trackingLabel: 'conversion:servicecontact',
    errorLabel: 'servicecontact',
  },
  fieldsConfig: {
    ...SERVICE_BOOKING_FALLBACK.fieldsConfig,
    serviceRequestInformation:
      'Sie haben eine Frage rund um die Themen Zubehör und Ersatzteile oder möchten einfach nur eine allgemeine Frage stellen? Bitte lassen Sie uns wissen, wie wir Ihnen weiterhelfen können.',
  },
  modaltypeToWriteInUrl: 'SERVICE_REQUEST',
  modalName: 'SERVICE_REQUEST',
};

const SERVICE_CONTACT = {
  payloadConfig: { ...basicConsultationPayload },
  trackingConfig: {
    trackingLabel: 'conversion:servicecontact',
    errorLabel: 'servicecontact',
  },
  fieldsConfig: {
    ...basicFieldsConfig,
    showServiceRequest: true,
    showAppointmentPersonalData: true,
    showInformationAndButtons: false,
    showInformationAndButtonsTypeService: true,
    useNestedPayloadType: true,
    requestUrl: '/api/v1/service-appointments/',
    showOSBLink: true,
    osbTitle: 'ServiceTermin buchen',
    osbText:
      'Sie möchten Ihren nächsten Werkstatttermin bequem online buchen, da z.B. Ihre nächste Fahrzeug-Wartung, ein Räderwechsel oder die HU/AU ansteht?',
    showOSBSeparationLine: true,
    serviceRequestTitle: 'Serviceberater kontaktieren',
  },
  modaltypeToWriteInUrl: 'SERVICE_CONTACT',
  mainHeader: 'Werkstatttermin vereinbaren',
  modalName: 'SERVICE_CONTACT',
};

const CONFIGURATOR = {
  payloadConfig: { ...basicConsultationPayload },
  trackingConfig: {
    trackingLabel: 'conversion:requestaconsultation_configurator',
    errorLabel: 'requestaconsultation',
  },
  fieldsConfig: {
    ...basicFieldsConfig,
    showConfigurator: true,
    showAppointmentDate: true,
    showAppointmentDescription: true,
    showAppointmentPersonalData: true,
    showInformationAndButtons: true,
    showAppointmentType: true,
  },
  mainHeader: 'Wunschmodell konfigurieren',
  modalName: 'CAR_CONFIGURATOR',
};

const CONSULTATION = {
  payloadConfig: { ...basicConsultationPayload },
  trackingConfig: {
    trackingLabel: 'conversion:requestaconsultation',
    errorLabel: 'requestaconsultation',
  },
  fieldsConfig: {
    ...basicFieldsConfig,
    showAppointmentDate: true,
    showAppointmentDescription: true,
    showAppointmentPersonalData: true,
    showAppointmentType: true,
    showInformationAndButtons: false,
    showInformationAndButtonsTypeService: true,
  },
  modaltypeToWriteInUrl: 'REQUEST_FOR_CONSULTATION',
  mainHeader: 'Beratungstermin',
  modalName: 'REQUEST_FOR_CONSULTATION',
};

const CONSULTATION_FK = {
  ...CONSULTATION,
  trackingConfig: {
    trackingLabel: 'conversion:requestaconsultation_fk',
    errorLabel: 'requestaconsultation_fk',
  },
  fieldsConfig: {
    ...CONSULTATION.fieldsConfig,
    showTabs: true,
    appointmentTypeInInformation: 'Beratungstermin',
    showInformationAndButtons: true,
    showInformationAndButtonsTypeService: false,
  },
  mainHeader: 'Individuelle Beratung',
  modaltypeToWriteInUrl: undefined,
  modalName: 'REQUEST_FOR_CONSULTATION_FK',
};

const CONSULTATION_WS = {
  ...CONSULTATION,
  payloadConfig: { ...basicConsultationPayload, title: { active: true, inputRequired: true } },
  trackingConfig: {
    trackingLabel: 'conversion:requestaconsultation_ws',
    errorLabel: 'requestaconsultation_ws',
  },
  fieldsConfig: {
    ...CONSULTATION.fieldsConfig,
    showAppointmentType: false,
    showTabs: true,
    showServiceRequest: true,
    showAppointmentDate: false,
    showAppointmentDescription: false,
    titleIsOptional: false,
    useNestedPayloadType: true,
    requestUrl: '/api/v1/service-appointments/',
    serviceRequestTitle: 'Serviceberater kontaktieren',
    serviceRequestInformation:
      'Sie haben eine Frage rund um die Themen Zubehör und Ersatzteile oder möchten einfach nur eine allgemeine Frage stellen? Bitte lassen Sie uns wissen, wie wir Ihnen weiterhelfen können.',
  },
  modaltypeToWriteInUrl: undefined,
  mainHeader: 'Individuelle Beratung',
  modalName: 'REQUEST_FOR_CONSULTATION_WS',
};

const CONSULTATION_OSBFB = {
  payloadConfig: { ...basicConsultationPayload, title: { active: true, inputRequired: true } },
  trackingConfig: {
    trackingLabel: 'conversion:servicecontact',
    errorLabel: 'servicecontact',
  },
  fieldsConfig: {
    ...basicFieldsConfig,
    showTabs: true,
    showServiceRequest: true,
    showAppointmentPersonalData: true,
    titleIsOptional: false,
    useNestedPayloadType: true,
    requestUrl: '/api/v1/service-appointments/',
    showInformationAndButtons: false,
    showInformationAndButtonsTypeService: true,
    serviceRequestInformation:
      'Sie haben eine Frage rund um die Themen Wartung, Teile und Zubehör oder möchten einfach nur eine allgemeine Frage stellen? Bitte lassen Sie uns wissen, wie wir Ihnen weiterhelfen können.',
  },
  modaltypeToWriteInUrl: 'REQUEST_FOR_CONSULTATION_OSBFB',
  mainHeader: 'Serviceberater kontaktieren',
  modalName: 'REQUEST_FOR_CONSULTATION_OSBFB',
};

const USED_CAR_EVALUATION_DISABLED = {
  payloadConfig: { ...basicConsultationPayload, title: { active: true, inputRequired: true } },
  trackingConfig: {
    trackingLabel: 'conversion:used_car_evaluation',
    errorLabel: 'used_car_evaluation',
  },
  fieldsConfig: {
    ...basicFieldsConfig,
    showServiceRequest: true,
    showAppointmentPersonalData: true,
    titleIsOptional: false,
    useNestedPayloadType: true,
    requestUrl: '/api/v1/service-appointments/',
    showInformationAndButtons: false,
    showInformationAndButtonsTypeService: true,
    serviceRequestInformation:
      'Für unseren Standort steht Ihnen die Gebrauchtwagenbewertung leider nicht zur Verfügung. Nehmen Sie Kontakt auf für eine individuelle Beratung.',
  },
  modaltypeToWriteInUrl: 'USED_CAR_EVALUATION',
  mainHeader: 'Gebrauchtwagenbewertung',
  modalName: 'USED_CAR_EVALUATION_DISABLED',
};

export function getStateConfig(formType) {
  if (formType === MODAL_TYPES.CAR_CONFIGURATOR.name) return CONFIGURATOR;
  if (formType === MODAL_TYPES.SERVICE_CONTACT.name) return SERVICE_CONTACT;
  if (formType === MODAL_TYPES.SERVICE_REQUEST.name) return SERVICE_REQUEST;
  if (formType === MODAL_TYPES.REQUEST_FOR_CONSULTATION.name) return CONSULTATION;
  if (formType === MODAL_TYPES.REQUEST_FOR_CONSULTATION_FK.name) return CONSULTATION_FK;
  if (formType === MODAL_TYPES.REQUEST_FOR_CONSULTATION_WS.name) return CONSULTATION_WS;
  if (formType === MODAL_TYPES.REQUEST_FOR_CONSULTATION_OSBFB.name) return CONSULTATION_OSBFB;
  if (formType === MODAL_TYPES.ONLINE_SERVICE_BOOKING.name) return ONLINE_SERVICE_BOOKING;
  if (formType === MODAL_TYPES.SERVICE_BOOKING_FALLBACK.name) return SERVICE_BOOKING_FALLBACK;
  if (formType === MODAL_TYPES.USED_CAR_EVALUATION_DISABLED.name)
    return USED_CAR_EVALUATION_DISABLED;
}

export function useNestedPayloadType(payload) {
  const nestedPayload = { ...payload };

  nestedPayload.comment = payload.comments;
  nestedPayload.dealerId = payload.dealer;
  nestedPayload.marketCode = payload.market;
  nestedPayload.customer = {
    email: payload.email,
    firstName: payload.firstName,
    lastName: payload.lastName,
    permissionConfig: { email: payload.emailOptIn, call: payload.telephoneOptIn },
    title: payload.title,
    address: {
      city: '',
      country: 'DE',
      street: '',
    },
  };

  nestedPayload.vehicle = {
    vehicleLicensePlate: 'nicht angegeben',
    vehicleModel: 'nicht angegeben',
    mileage: 0,
    mileageUnit: 'km',
  };

  nestedPayload.preferredDate = '2999-01-01';
  nestedPayload.preferredTime = '14:00:00';
  nestedPayload.serviceType = 'Other';

  delete nestedPayload.dealer;
  delete nestedPayload.comments;
  delete nestedPayload.market;
  delete nestedPayload.email;
  delete nestedPayload.firstName;
  delete nestedPayload.lastName;
  delete nestedPayload.emailOptIn;
  delete nestedPayload.telephoneOptIn;
  delete nestedPayload.title;
  delete nestedPayload.type;

  return nestedPayload;
}
